import { render, staticRenderFns } from "./HowToCook.vue?vue&type=template&id=3456e32c&scoped=true&"
import script from "./HowToCook.vue?vue&type=script&lang=js&"
export * from "./HowToCook.vue?vue&type=script&lang=js&"
import style0 from "./HowToCook.vue?vue&type=style&index=0&id=3456e32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456e32c",
  null
  
)

export default component.exports